import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { SharedModule } from '../shared/shared.module';
import { AcceptInvitePageComponent } from './pages/accept-invite-page/accept-invite-page.component';
import { AuthTemplateComponent } from './components/auth-template/auth-template.component';
import { RegisterFormComponent } from './components/register-form/register-form.component';
import { VendorRegistrationPageComponent } from './pages/vendor-registration-page/vendor-registration-page.component';
import { VerifyEmailAddressComponent } from './pages/verify-email-address/verify-email-address.component';
import { ForgottenPasswordPageComponent } from './pages/forgotten-password-page/forgotten-password-page.component';
import { PasswordResetPageComponent } from './pages/password-reset-page/password-reset-page.component';
import { TwoFactorAuthPageComponent } from './pages/two-factor-auth-page/two-factor-auth-page.component';
import { PageSectionComponent } from '../shared/components/page-section.component';

@NgModule({
  declarations: [
    AuthTemplateComponent,
    LoginFormComponent,
    LoginPageComponent,
    AcceptInvitePageComponent,
    RegisterFormComponent,
    VendorRegistrationPageComponent,
    VerifyEmailAddressComponent,
    ForgottenPasswordPageComponent,
    PasswordResetPageComponent,
    TwoFactorAuthPageComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    SharedModule,
    PageSectionComponent,
    NgOptimizedImage,
  ],
})
export class AuthModule {}
